import { defineRule } from 'vee-validate';

export function defineValidationRules(t) {
  defineRule('required', (value, [field]) => {
    const translatedField = t(`fields.${field}`, { fallback: field });
    if (!value || !value.length) {
      return t('validation.required', { field: translatedField });
    }
    return true;
  });

  defineRule('email', (value) => {
    if (
      // eslint-disable-next-line no-control-regex
      !/^[^\s]+(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(
        value
      )
    ) {
      return t('validation.invalidEmail');
    }
    return true;
  });

  defineRule('max', (value, [limit]) => {
    if (value.length > limit) {
      return t('validation.max', { limit });
    }
    return true;
  });

  defineRule('letter', (value) => {
    // eslint-disable-next-line no-useless-escape
    if (/^[0-9]/.test(value) || /^[!-\/:-@[-`{-~¡-¿×÷ʰ-ͯ]/.test(value)) {
      return t('validation.letter');
    }
    return true;
  });

  defineRule('min', (value, [limit, field]) => {
    const translatedField = t(`fields.${field}`, { fallback: field });
    if (value.length < limit) {
      return t('validation.min', { field: translatedField, limit });
    }
    return true;
  });

  defineRule('password', (value) => {
    if (!/^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}/.test(value)) {
      return t('validation.password');
    }
    return true;
  });

  defineRule('confirmed', (value, [target, field]) => {
    if (value === target) {
      return true;
    }

    return t('validation.confirmed', { field });
  });

  defineRule('confirmed_case_insensitive', (value, [target, field]) => {
    if (value.toLowerCase() === target.toLowerCase()) {
      return true;
    }

    return t('validation.confirmed', { field });
  });
}
